// extracted by mini-css-extract-plugin
export var standaloneTable = "_jm-0";
export var standaloneTableWithBodyFill = "_jm-1";
export var withExtraHeader = "_jm-2";